import { render, staticRenderFns } from "./datascope.vue?vue&type=template&id=7b554dfc"
import script from "./datascope.vue?vue&type=script&lang=js"
export * from "./datascope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports